import React from "react";
import { Link } from "react-router-dom";

/**
 * Detail / profile page layout matching the Active Admin reference.
 *
 * <DetailLayout
 *   breadcrumb={[{ label: "Dashboard", to: "/admin" }, { label: "Orders", to: "/admin/order" }]}
 *   title="Order detail"
 *   subtitle="#abc123"
 *   actions={<><button>Approve</button><button>Reject</button></>}
 * >
 *   <DetailSection title="Order Details">...</DetailSection>
 * </DetailLayout>
 */
const DetailLayout = ({ breadcrumb, title, subtitle, actions, children }) => {
  return (
    <div className="detail-layout">
      <div className="detail-layout__header">
        <div className="detail-layout__title-block">
          {breadcrumb && breadcrumb.length > 0 && (
            <ul className="breadcrumb detail-layout__breadcrumb">
              {breadcrumb.map((b, i) => (
                <li
                  key={i}
                  className={`breadcrumb-item${
                    i === breadcrumb.length - 1 ? " active" : ""
                  }`}
                >
                  {b.to && i !== breadcrumb.length - 1 ? (
                    <Link to={b.to}>{b.label}</Link>
                  ) : (
                    b.label
                  )}
                </li>
              ))}
            </ul>
          )}
          <h3 className="detail-layout__title">
            {title}
            {subtitle && (
              <span className="detail-layout__subtitle"> {subtitle}</span>
            )}
          </h3>
        </div>
        {actions && <div className="detail-layout__actions">{actions}</div>}
      </div>
      <div className="detail-layout__body">{children}</div>
    </div>
  );
};

export default DetailLayout;
